// extracted by mini-css-extract-plugin
export default {"root":"IconHunting_root__AXcm8"};